import React, { useState, useContext } from 'react';
import { GuidService } from 'ui-components/services/guid-service';
import { ChildrenPropType } from '../../../prop-types/children';

const SplitShipSessionContext = React.createContext({});
export const useSplitShipSessionId = () => useContext(SplitShipSessionContext);

const SplitShipSessionProvider = ({ children }) => {
  const [sessionId] = useState(GuidService.newGuid());

  return <SplitShipSessionContext.Provider value={sessionId}>{children}</SplitShipSessionContext.Provider>;
};

SplitShipSessionProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};

export { SplitShipSessionProvider };
